import { appURLs } from "@/app/constants.mjs";
import { appLog } from "@/util/dev.mjs";

const origUrl = appURLs.VALORANT;

export function setup() {
  appLog("[VAL] 🦀 Enabled");
  appURLs.VALORANT = appURLs.VALORANT_V2;
}

export function teardown() {
  appURLs.VALORANT = origUrl;
}
